import { useFilterOptions } from './useFiltersOptions';
import sortOptions from '@/constants/sortOptions';

export const useDeliveredFilterStore = useFilterOptions(
  'deliveredFilterStore',
  'api/transport-requests/manage/Delivered',
  {
    sortObj: sortOptions.dispatchedDate
  },
);
